import React from "react";
import { FormattedMessage } from "react-intl";

import { NotificationSettingsChoices } from "~/ui/context";

export const NOTIFICATIONS_SETTINGS_CHECKBOXES = [
  {
    value: NotificationSettingsChoices.Likes,
    message: (
      <FormattedMessage
        defaultMessage="By disabling, you will no longer receive notifications for post likes on this device."
        id="YNfBCv"
      />
    ),
    title: <FormattedMessage defaultMessage="Likes" id="2slIPX" />,
  },
  {
    value: NotificationSettingsChoices.Comments,
    message: (
      <FormattedMessage
        defaultMessage="By disabling, you will no longer receive notifications for post comments on this device."
        id="gECZGD"
      />
    ),
    title: <FormattedMessage defaultMessage="Comments" id="wCgTu5" />,
  },
  {
    value: NotificationSettingsChoices.Follow,
    message: (
      <FormattedMessage
        defaultMessage="By disabling, you will no longer receive notifications for new followers on this device."
        id="MunfOo"
      />
    ),
    title: <FormattedMessage defaultMessage="Follow" id="ieGrWo" />,
  },
  {
    value: NotificationSettingsChoices.Chat,
    message: (
      <FormattedMessage
        defaultMessage="By disabling, you will no longer receive notifications for chat messages on this device."
        id="TiJmLf"
      />
    ),
    title: <FormattedMessage defaultMessage="Chat messages" id="SCYmnE" />,
  },
];
